import React from "react";

export interface PageLayoutProps {
  children: React.ReactNode;
  // Pass Tailwind/CSS class strings. If undefined/null, they should resolve to "".
  horizontalPadding?: string;
  verticalPadding?: string;
  maxWidthClassName?: string;
  outerContainerClassName?: string;
}

export const FullPageLayout: React.FC<PageLayoutProps> = ({
  children,
  horizontalPadding,
  verticalPadding,
  maxWidthClassName,
  outerContainerClassName,
}) => {
  // Resolve nullish props to empty strings to avoid injecting "undefined"/"null" into class attributes
  const effectiveHorizontalPadding = horizontalPadding ?? "";
  const effectiveVerticalPadding = verticalPadding ?? "";
  const effectiveMaxWidth = maxWidthClassName ?? "";
  const effectiveOuterContainer = outerContainerClassName ?? "";

  return (
    <div className={`w-full ${effectiveOuterContainer}`}>
      <div className={`w-auto mx-auto ${effectiveHorizontalPadding}`}>
        <div className={`flex-1 content-center ${effectiveMaxWidth} mx-auto w-full ${effectiveVerticalPadding}`}>
          {children}
        </div>
      </div>
    </div>
  );
};
